/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Mild_Yak_LiftInputs */

const en_full_mild_yak_lift = /** @type {(inputs: Full_Mild_Yak_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const de_full_mild_yak_lift = /** @type {(inputs: Full_Mild_Yak_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablehnen`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Full_Mild_Yak_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_mild_yak_lift = /** @type {((inputs?: Full_Mild_Yak_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Mild_Yak_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_mild_yak_lift(inputs)
	return de_full_mild_yak_lift(inputs)
});